import { useCheckConfigurationAndRewardOfChannelQuery } from '@/types/generated/graphql';
import { SuspenseQueryHookFetchPolicy } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import useRouteChecker from '@shared/hooks/use-route-checker';

export function useChannelReward(fetchPolicy: SuspenseQueryHookFetchPolicy = 'cache-first') {
  const { pathname } = useLocation();
  const { isSignUpPage } = useRouteChecker({
    pathname,
  });
  const { data, loading, refetch } = useCheckConfigurationAndRewardOfChannelQuery({
    fetchPolicy,
    skip: isSignUpPage,
  });

  const availableRewardCount = data?.checkConfigurationAndRewardOfChannel?.data?.availableRewardCount ?? 0;
  const requiresDisposition = data?.checkConfigurationAndRewardOfChannel?.data?.requiresDisposition ?? false;

  return {
    availableRewardCount,
    requiresDisposition,
    refetch,
    loading,
  };
}
